import React, { Component } from 'react';

class NameDisplay extends Component {

  render() {
    let name = this.props.name;
    let truncNum = this.props.truncNum;
    if(!!name && name !== 'بدون عنوان'){
      return (
        <span>
          { name.trunc(truncNum) }
        </span>
      );
    }
    else{
      return (
        <span className="empty-name" >
          بدون عنوان
        </span>
      );
    }
  }
}

export default NameDisplay;